


















import { Component, Vue } from 'vue-property-decorator';
import Teacher from '@/services/Teacher';
import Roles from '@/services/Roles';

@Component
export default class TeacherMenu extends Vue {
  get isAdmin() {
    return false; //Roles.isAdmin();
  }
}
